
var theme = window.theme || theme || {} ;
/*
    theme.AjaxCart
    Performs ajax calls to Shopify.
*/
theme.AjaxCart = (function () {
    return {
        /***** Public Properties *****/
        // Custom event types. NOTE: Events are tied to the
        // document's body.
        eventStrs: {
            addToCartSuccess: 'theme:ajaxCart:addSuccess',
            addToCartError: 'theme:ajaxCart:addError',
            updateCartSuccess: 'theme:ajaxCart:updateSuccess',
            updateCartError: 'theme:ajaxCart:updateError',
            getCartSuccess: 'theme:ajaxCart:getCartSuccess',
            getCartError: 'theme:ajaxCart:getCartError'
        },
        /***** Public Methods *****/
        /*
            =function addToCart(variantId, qty)
            Adds qty amount of the variant that has the passed in ID
            to the cart. Also adds line properties if any are available.
            Triggers an add to cart success or error event when done.
            =Params
            (int) variantId: The ID of the variant to add
            (int) qty: The amount of the variant to add
            (jQuery object) properties: The line properties for the product
        */
      	addToCart: function (variantId, qty, properties,ac_type) {
        	var self = this;
        	var data = {
          		quantity: qty,
          		id: variantId
        	};
	        //$('#ajax_loader').show();
	        //Only do this code if we have properties to use
	        if(properties && !$.isEmptyObject(properties)) {
	          	var data = {
            		quantity: qty,
	            	id: variantId,
	            	properties: {
	              		'Hinge': properties
	            	}
	          	};
	        }
	        //Perform the AJAX call
	        this._doAjax('/cart/add.js', data,function(resultObj) { 
	          	$('body').trigger(self.eventStrs.addToCartSuccess);
	          	if(ac_type == 'coll' && is_cus ==true){ 
	            	//theme.AjaxCart.getCartData('coll');
	            	get_miniCart();
	          	}else{
		            /*$('#ajax_loader').hide();
		            $('#main_popup_cart').fadeIn().delay(1500).fadeOut();
		            $('.ct_title').text(resultObj['title']);
		            //$('.crt_wrapper').fadeIn().delay(1000).fadeOut();
		            $('.crt_wrapper').addClass('fadeInDown');
		            setTimeout(function(){
		            	$('.crt_wrapper').removeClass('fadeInDown');
		            },1500);*/
	          	}
        	}, function(resultObj) {
          		$('body').trigger(self.eventStrs.addToCartError);
            });
        },
        /*
        =function updateCart(cartStr)
        Updates the cart to reflect the passed in string. Triggers an
        update cart succes or error event when done.
        =Params
        (string) cartStr: The string that the cart should reflect
        */
      	updateCart: function(cartStr,ac_type) {
	        //console.log(cartStr);
	        var self = this;
	        this._doAjax('/cart/update.js', cartStr, function(resultObj) {
	          	$('body').trigger(self.eventStrs.updateCartSuccess, [resultObj]);
	          	if(ac_type == 'coll' && is_cus ==true){
		            create_miniCart(resultObj);
		            get_miniCart();
	          	}else{
	            	//$('#ajax_loader').hide();
	          	}
	        }, function(resultObj) {
	          	$('body').trigger(self.eventStrs.updateCartError, [resultObj]);
	        });
      	},
      	/*
        =function getCartData()
        Gets the cart object from Shopify. Triggers a get cart
        data succes or error event when done.
        */
        getCartData: function(ac_type) {
            var self = this;
            this._doAjax('/cart.js', null, function(cart) {
              	$('body').trigger(self.eventStrs.getCartSuccess, [cart]);
              	if(ac_type == 'coll' && is_cus ==true){
	                create_miniCart(cart);
	                get_miniCart();
              	}else{
                	//$('#ajax_loader').hide();
              	}
            }, function(cart) {
                $('body').trigger(self.eventStrs.getCartError, [cart]);
            });
        },
        
        /***** Private Methods *****/
        /*
        =function _doAjax(url, data, successFunc, errorFunc)
        Performs an ajax call using the passed in information
        =Params
        (string) url: The URL to post to
        (object) data: The data to post
        (function) successFunc: (optional) The function to call on success
        (function) errorFunc: (optional) The function to call on error
        */
      	_doAjax: function (url, data, successFunc, errorFunc) {
	        var self = this;
	        $.ajax({
				type: 'POST',
				url: url,
				data: data,
				dataType: 'json',
	          	success: function(resultObj) {
		            if($.isFunction(successFunc)) {
		              	successFunc(resultObj);
		            }
	          	},
	          	error: function(resultObj) {
	            	if($.isFunction(errorFunc)) {
	              		errorFunc(resultObj);
	            	}
	          	}
	        });
      	}
    };
}());

var handle_ary={};
var app_url="//cabinetrysupply.com/kabinetdepotquote";
jQuery(document).ready(function(){

  theme.AjaxCart.getCartData('coll');//Get cart on load
  
  //Update mini cart
  jQuery('.btn-update').click(function() {
    jQuery('#ajax_loader').show();
    var data=jQuery('#mq_cart_frm').serialize();
    theme.AjaxCart.updateCart(data,'coll');
	
    setTimeout(function(){
      jQuery.getJSON('/cart.js', function(cart) {
        //console.log(cart.item_count);
        var total_item_count = cart.item_count;
        jQuery('a.site-header-cart--button .site-header-cart--count').attr('data-header-cart-count', total_item_count);
      });
    }, 300);
  });
  
  //increase or decrease Qty
  jQuery(document).on('click', '#footercart .minus_btn_cab,#footercart .plus_btn_cab,#quote_list .minus_btn_cab,#quote_list .plus_btn_cab', function() {
    var qty_num=jQuery(this).parents('TD').find('input[type="number"]').val();
    
    if(jQuery(this).hasClass('plus_btn_cab')){
      qty_num=(qty_num <= 0 || qty_num ==''?0:qty_num);
      qty_num=parseInt(qty_num)+1;
      jQuery(this).parents('TD').find('input[type="number"]').val(qty_num);
    }else if(qty_num > 1){
      qty_num=parseInt(qty_num)-1;
      jQuery(this).parents('TD').find('input[type="number"]').val(qty_num);
    }
    setTimeout(function(){
      jQuery('#footercart .button.btn-update').trigger("click");
    }, 300);
  });
  console.log('working..')
});

function get_miniCart(){

  jQuery.ajax({
    method: "get",
    url: "/cart?view=json",
    success: function(data) {
      console.log(data);
      jQuery('.content_cart .content_cart_inner').remove();
      jQuery('.content_cart').append(data); 
    },
    error: function(err) {
      console.log(err);
    }
  })
  handle_ary={};
  jQuery.ajax({
    url: "/pages/mini-cart-layout",
    type: 'GET',
    dataType: 'html',
    success: function(data) { 

      if(data.trim() == ''){
        if(who_cust){
          jQuery("#footercart .saw-cart-original-total").removeAttr('style');
        }
        jQuery("#footercart #pro_count").html('0');
        jQuery("#footercart .saw-cart-original-total").html('$ 0.00');
        jQuery("#footercart .saw-cart-total").html('');
        jQuery('.floating-empty-cart').show();
        jQuery('.footer-cart-content').hide(); 
      }else{
        jQuery('.floating-empty-cart').hide();
        jQuery('.footer-cart-content').show(); 
        jQuery('#shopping-cart-table tbody').html(data); 

        if(who_cust){
          sa_SAWCartCheck();
        }else{
          jQuery('.saw-cart-total').html("");
          jQuery("#pro_count").html(cart_item_count);
          jQuery(".saw-cart-original-total").html(cart_tl);
          jQuery('#ajax_loader').hide();
        } 

      }
      // jQuery('#footercart').show();
      
      setTimeout(function(){
        jQuery.getJSON('/cart.js', function(cart) {
          //console.log(cart.item_count);
          var total_item_count = cart.item_count;
          jQuery('a.site-header-cart--button .site-header-cart--count,.content_cart_toggle .cart--count').attr('data-header-cart-count', total_item_count);
          jQuery('.content_cart_toggle .cart--count').text(total_item_count)
          
        });
      }, 300);

    }
  });
}

//Create mini cart html
function create_miniCart(cartdata){
  var cart_ht='';
  //handle_ary={};
 
  if(cartdata['items'].length >=1){

    jQuery.each(cartdata['items'],function(i,v){
      var p = (v['price'])/100;
      var price = p.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      var l_price=(v['line_price'])/100;
      var line_price = l_price.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      if (typeof (handle_ary[v['variant_id']]) === "undefined") {
      }
    });
     
  } 
}

//Remove product from mini cart
function mq_item_Remove(obj, e,type) {
  jQuery('#ajax_loader').show();
  var vId = jQuery(obj).attr("vid");
  if(type == 'all'){//Remove all 
    var url="/cart/clear";
    var ha_data="";
  }else{//Remove seleted
    var url="/cart/change.js";
    var ha_data={"quantity":0,"id":vId};
  }
  jQuery.ajax({
    url: url,
    type: 'POST',
    data:ha_data,
    dataType: 'json',
    success: function(cartdata) { 
      jQuery('#ajax_loader').hide();
      create_miniCart(cartdata);
      get_miniCart();
    }
  });
}

$(document).on('click','.ctm_clear_cart',function(e) {
  e.preventDefault();
  $.ajax({
    method: "get",
    url: "/cart/clear.js",
    success:function(data) {
      console.log(data);
      get_miniCart();
    },
    error: function(err) {
      console.log(err);
    }
  })  
  return false;  
})

$(document).on('click','.ctm_plus',function(e) {
  e.preventDefault();
  var val = parseInt($(this).closest('tr').find('.ctm_qty').data('qty')) + 1;
  var id = parseInt($(this).closest('tr').find('.ctm_qty').data('var-id'));
  $.ajax({
    method: "post",
    url: "/cart/change.js",
    data:{
      id: id,
      quantity: val  
    },
    success: function(data) {
     get_miniCart();
    },
    error: function(err) {
       console.log(err) 
    }  
  })  
  return false;  
})
$(document).on('click','.ctm_minus',function(e) {
  e.preventDefault();
  var val = parseInt($(this).closest('tr').find('.ctm_qty').data('qty')) - 1;
  var id = parseInt($(this).closest('tr').find('.ctm_qty').data('var-id'));
  $.ajax({
    method: "post",
    url: "/cart/change.js",
    data:{
      id: id,
      quantity: val  
    },
    success: function(data) {
     get_miniCart();
    },
    error: function(err) {
       console.log(err) 
    }  
  })  
  return false;  
})

$(document).on('click','.my_close_cart',function(e) {
  e.preventDefault();
  $('.content_cart_toggle').trigger('click');  
  return false;  
})


